export const WorkData = [
    {
        company: "Professional Experience",
        designation: "Senior Mobile & Frontend Developer",
        dateJoining: "2015",
        dateEnd: "Present",
        companyLogo: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
        work: "10+ years of progressive experience building scalable, high-performance applications across fintech, e-commerce, and blockchain domains. Proven track record leading development teams, architecting mobile solutions for 1M+ users, and mentoring junior developers to senior roles. Expert in React Native, React.js, and modern JavaScript ecosystem with hands-on experience in full-stack development."
    },
]